import * as angular from "angular";

export class ConfirmDialogService {

  pathUrls: any = {
    regular: 'app/modules/commons/views/tmpl/confirm-dialog.html',
    mask: 'app/modules/commons/views/tmpl/confirm-mask-dialog.html'
  };

  constructor(private $mdDialog) {
  }

  confirm(title?, textContent?, event?) {
    return this.show(title, textContent, null, null, event, false);
  }
  confirmWithValidation(title?, textContent?, dataObject?, textValidation?, event?) {
    return this.show(title, textContent, null, dataObject, event, false, null, textValidation);
  }

  confirmWithInfo(title, textContent, extraInfo, dataObject?, event?) {
    return this.show(title, textContent, extraInfo, dataObject, event, false);
  }

  confirmWithActions(title, textContent, actions, event?) {
    return this.show(title, textContent, undefined, null, event, false, actions);
  }

  confirmMask(title, textContent, event) {
    return this.showMask(title, textContent, null, event, true);
  }

  confirmEntity(title, confirmText1, confirmText2, placeholder, entity, regex) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope) {

        $scope.header = title;
        $scope.confirmText1 = confirmText1;
        $scope.confirmText2 = confirmText2;
        $scope.placeholder = placeholder;
        $scope.entity = entity;
        $scope.regex = regex;
        $scope.userInput = '';


        //////////////////////

        $scope.confirm = (form) => {
          form.$setSubmitted(true);

          if (form.$valid) {
            self.$mdDialog.hide();
          }
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }
      },
      templateUrl: 'app/modules/commons/views/tmpl/confirm-entity.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: true
    });
  }

  confirmState(event) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope) {


        //////////////////////

        $scope.leave = () => {
          self.$mdDialog.hide();
        }

        $scope.stay = () => {
          self.$mdDialog.cancel();
        }
      },
      templateUrl: 'app/modules/commons/views/tmpl/confirm-state-dialog.html',
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true
    });
  }

  // ******************************
  //        Private methods
  // ******************************

  private show(title, textContent, extraInfo, dataObject, event, maskView, actions?, textValidation?) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope, $translate) {
        $scope.selectedLanguage =  $translate.use();
        $scope.header = title;
        $scope.body = textContent;
        $scope.dataObject = dataObject;
        $scope.extraInfo = extraInfo;
        $scope.actions = actions;

        $scope.isValidationEnabled = !!textValidation;
        $scope.validationText = textValidation;
        $scope.isValid = {
          enabled: false
        };

        //////////////////////

        $scope.confirm = () => {
          self.$mdDialog.hide($scope.actions);
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }
      },
      templateUrl: this.getTemplateUrl(maskView),
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true
    });

  }

  private showMask(title, textContent, extraInfo, event, maskView) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope) {

        $scope.header = title;
        $scope.body = textContent;
        $scope.extraInfo = extraInfo;


        //////////////////////

        $scope.confirm = (shouldMask) => {
          self.$mdDialog.hide(shouldMask);
        }

        $scope.cancel = () => {
          self.$mdDialog.cancel();
        }
      },
      templateUrl: this.getTemplateUrl(maskView),
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true
    });

  }

  private getTemplateUrl(maskView) {
    return maskView ? this.pathUrls['mask'] : this.pathUrls['regular'];
  }
}

angular
  .module('bringoz.admin.commons')
  .service('confirmDialogService', ConfirmDialogService);

